/**
 * The "Try the new Grid" switch (#1766).
 *
 * A per-user preference in the same server-backed store as the job page's
 * "Try the new job page" switch (`user_preferences`, /api/me/preferences), so
 * it follows a dispatcher from desk to laptop and needs no migration. Default
 * OFF: until a person flips it for themselves the Grid is exactly the classic
 * board. Built to threads/new-grid/mockup.html.
 */
import { toast } from "sonner";
import { useUserPreference } from "@/lib/user-preference";

export const NEW_GRID_PREF_KEY = "grid.new-grid";

export function useNewGridSwitch(): { on: boolean; set: (on: boolean) => void; loaded: boolean } {
    const [value, set, { loaded }] = useUserPreference<boolean>(NEW_GRID_PREF_KEY, false, {
        onError: () => toast.error("Couldn't save the Grid switch. It's back the way it was."),
    });
    return { on: value === true, set, loaded };
}
